import { connect } from 'react-redux';
import _ from 'lodash';

import {
  addFilterClause,
  copyFilter,
  removeFilter,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseField,
  setFilterClauseOperator,
  setFilterClauseValue,
  setFilterVisibility,
  setOthersFilter,
} from '../../actions/events/events';
import {
  getEventFilter,
  getEventName,
  getEventOthersFilter,
  getEvents,
  getFieldPathKeys,
  getFieldPathsFor,
  getMetainf,
  getPeriodsState,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import EventFilterContainer from '../../components/filter/EventFilterContainer';
import {
  filterClauses,
  getEventAttributes,
  getTransferFieldsObject,
  isNotEmptyClause,
} from '../../utils/filter';

const mapStateToProps = (state, { id }) => {
  const filter = getEventFilter(state, id);
  const othersFilter = getEventOthersFilter(state, id);
  const isFiltersValue = !!filter.clauses.find(
    (clause) => clause.id === othersFilter && isNotEmptyClause(clause)
  );

  // если есть доп периоды - дисаблим
  const { periods } = getPeriodsState(state, id);
  const firstPeriodIsEmpty = periods[0].from === '' && periods[0].to === '';

  const disabled = periods.length > 1 || !firstPeriodIsEmpty;

  return {
    othersFilter,
    isFiltersValue,
    composeEvents: getEvents(state),
    getFieldFor: (path) => getFieldPathsFor(state, path),
    getFieldKeys: () => getFieldPathKeys(state),
    metainf: getMetainf(state, getEventName(state, id)),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    disabled,
    isEvent: true,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  setFilterVisibility: () => dispatch(setFilterVisibility(id)),
  onAddFilterClause: (...rest) => dispatch(addFilterClause(id, ...rest)),
  onCopy: (...rest) => dispatch(copyFilter(id, ...rest)),
  onRemoveFilter: () => dispatch(removeFilter(id)),
  onRemoveFilterClause: (...rest) => dispatch(removeFilterClause(id, ...rest)),
  onSelectFilterClauseField: (...rest) => dispatch(setFilterClauseField(id, ...rest)),
  onFilterClauseValueChange: (...rest) => dispatch(setFilterClauseValue(id, ...rest)),
  onSetClausesConcatOperator: (...rest) => dispatch(setClausesConcatOperator(id, ...rest)),
  onSelectFilterClauseOperator: (...rest) => dispatch(setFilterClauseOperator(id, ...rest)),
  onOthersChange: (clauseId) => dispatch(setOthersFilter(id, clauseId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCopyFilter: (clauses) => {
    let copyClauses = clauses.filter((clause) => clause.field);
    if (copyClauses.length) {
      // ивент с которого копируется фильтр.
      const firstEvent = stateProps.composeEvents.find((event) =>
        event.filter.clauses.find((clause) => clause.id === copyClauses?.[0].id)
      );
      // тот ивент, на который копируется фильтр.
      const secondEvent = stateProps.composeEvents.find((event) => event.id === ownProps.id);

      const fieldTypes = copyClauses.map(({ field }) =>
        stateProps
          .getFieldKeys()
          .flatMap((pathKey) => stateProps.getFieldFor(pathKey))
          .find((s) => s.path === field)
      );

      // если ивенты не равны то: копируются условия только с одинаковым лейблом, при этом один и тот же лейбл
      // ссылается на разные поля для каждого ивента, поэтому надо достать по лейблу нужный path
      if (firstEvent.name !== secondEvent.name) {
        const { firstEventFields, secondEventFields } = getEventAttributes(
          stateProps.metainf,
          firstEvent.name,
          secondEvent.name
        );
        // общие атрибуты по label
        const commonAttributes = _.intersectionBy(firstEventFields, secondEventFields, 'label');

        const filteredFields = getTransferFieldsObject(
          fieldTypes,
          commonAttributes,
          secondEventFields
        );

        copyClauses = copyClauses.reduce((res, clause) => {
          if (filteredFields[clause.field]) {
            return res.concat({ ...clause, field: filteredFields[clause.field] });
          }

          return res;
        }, []);
      }
    }

    dispatchProps.onCopy(filterClauses(stateProps.metainf, copyClauses));
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventFilterContainer);
